import { Verify } from "@stories/pages/Authenticate/Verify";

export const VerifyView = () => {
  return <Verify />;
};
